import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Command, CommandInput, CommandList, CommandEmpty, CommandItem } from '@/components/ui/command';
import { CaretDown } from '@phosphor-icons/react';

// Campo de pesquisa com autocomplete para escolher uma paciente numa lista longa.
// Filtro em tempo real (cmdk) sobre a lista completa recebida via prop `patients`.
export function PatientAutocomplete({ patients = [], value, onChange, placeholder = 'Escolher paciente...', testId = 'patient-autocomplete' }) {
  const [open, setOpen] = useState(false);
  const selected = patients.find(p => p.user_id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="flex-1 flex items-center justify-between gap-1 border border-brand-border rounded-lg px-2 py-1.5 text-xs bg-white text-left min-w-0"
          data-testid={testId}
        >
          <span className={`truncate ${selected ? 'text-brand-text' : 'text-brand-muted'}`}>{selected ? selected.name : placeholder}</span>
          <CaretDown size={12} className="text-brand-muted flex-shrink-0" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-72" align="start">
        <Command>
          <CommandInput placeholder="Pesquisar paciente..." data-testid={`${testId}-search`} />
          <CommandList className="max-h-64">
            <CommandEmpty>Sem resultados.</CommandEmpty>
            {patients.map(p => (
              <CommandItem
                key={p.user_id}
                value={p.name}
                onSelect={() => { onChange(p.user_id); setOpen(false); }}
                data-testid={`${testId}-option-${p.user_id}`}
              >
                <span className="truncate">{p.name}</span>
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}

export default PatientAutocomplete;
